module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/disney-logo-8c0092c57258aa0c8b01012343874494.png";